import {i18n} from "@/i18n";

export const GALLERY_TAB_TYPE = {
    MEDIA: 'media',
    FAVOURITE: 'favourite', 
    ALL_MEDIA: 'all_media',
    PURCHASED: 'purchased',
    UNPURCHASED: 'unpurchased'
}

export const GALLERY_TAB_TYPE_LABELS = {
    [GALLERY_TAB_TYPE.MEDIA]: i18n.t('gallery.tabs.media'),
    [GALLERY_TAB_TYPE.FAVOURITE]: i18n.t('gallery.tabs.favourite'),
    [GALLERY_TAB_TYPE.ALL_MEDIA]: i18n.t('gallery.tabs.all_media'),
    [GALLERY_TAB_TYPE.PURCHASED]: i18n.t('gallery.tabs.purchased'),
    [GALLERY_TAB_TYPE.UNPURCHASED]: i18n.t('gallery.tabs.unpurchased')
}

export const GALLERY_TAB_TYPE_OPTIONS = Object.entries(GALLERY_TAB_TYPE_LABELS).map(([value, label]) => ({
    value,
    label
}))